import { Box, BoxProps, ButtonNew, ButtonProps, ColorOptions, Icon, ModBox, Spacer, Text, TextNew } from '@jfs/ui-new'
import { FC, useEffect } from 'react'
import { CircularProgress } from '../../comps/CircularProgress'
import { useLazyApiData, useStores } from '../../data/store'

interface UploadFileProgressProps {
  hide?: Boolean
  progress?: number
  fileName?: any
  onHandleCancelChangeFile?: any
  navToHistory?: any
  mid?: string
  file?: any
  resetState?: any
}

const BulkBeneficiaryUploadFileProgress: FC<UploadFileProgressProps> = ({
  hide = false,
  progress = 0,
  fileName,
  onHandleCancelChangeFile,
  navToHistory,
  mid,
  file,
  resetState,
}: UploadFileProgressProps) => {
  const { uploadBulkBeneficiaryFile, setFileUploadProgress, setUploadStatus, uploadStatus, size, uploadedFileId } =
    useStores((store) => ({
      uploadBulkBeneficiaryFile: store?.beneficiaryOnboarding?.bulkOnboardfileUpload,
      uploadStatus: store?.beneficiaryOnboarding?.uploadStatus,
      setUploadStatus: store?.beneficiaryOnboarding?.setUploadStatus,
      size: store?.beneficiaryOnboarding?.size,
      setFileUploadProgress: store?.settings?.metaData?.setFileUploadProgress,
      uploadedFileId: store?.beneficiaryOnboarding?.uploadedFileId,
    }))

  const [uploadFile, uploadFileHandler] = useLazyApiData(uploadBulkBeneficiaryFile)

  useEffect(() => {
    if (uploadFileHandler?.state === 'fulfilled') {
      setUploadStatus('UPLOADED')
      navToHistory()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadFileHandler, uploadFileHandler.state, uploadFileHandler?.data?.status])

  useEffect(() => {
    if (uploadStatus !== 'UPLOADED' && uploadStatus !== 'PROCESSED') {
      uploadFile(file, mid)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file, fileName, mid, size])

  if (hide) {
    return null
  }

  return (
    <Box {...styles.container}>
      <Box {...styles.content}>
        {(uploadStatus === 'IN_PROGRESS' || uploadStatus === 'IN_PROCESS') && (
          <CircularProgress percentage={progress} color={'#0186B0'}>
            <Box {...styles.progressView}>
              <TextNew title={progress + '%'} color={'PRIMARY'} fontFamily={'jiotype-medium'} fontSize={14} />
            </Box>
          </CircularProgress>
        )}
        {uploadStatus === 'UPLOADED' && (
          <Box {...styles.fileContainer}>
            <Icon color={'BLACK_21'} id={'SETTLEMENTS'} size={24} />
          </Box>
        )}
        {uploadStatus === 'PROCESSED' && (
          <Box {...styles.filledStyle}>
            <Icon id={'TICKMARK'} color={'#3F8C3A' as ColorOptions} size={24} />
          </Box>
        )}
        <ModBox {...styles.contentContainer} show={false}>
          <Text
            fontFamily={'jiotype-medium'}
            fontSize={12}
            color={'BRAND_COLOR_GRAY_1'}
            testID="bulkRefundFileUploadStatusMsg">
            {uploadStatus === 'IN_PROGRESS'
              ? 'File upload in progress…'
              : uploadStatus === 'UPLOADED'
              ? fileName ?? ''
              : uploadStatus === 'IN_PROCESS'
              ? 'File upload in progress…'
              : uploadStatus === 'PROCESSED'
              ? 'Bulk Beneficiary request initiated successfully'
              : null}
          </Text>
          <Spacer size={16} />
          <Text fontFamily={'jiotype-bold'} fontSize={14} color={'BLACK_21'}>
            {uploadStatus === 'UPLOADED' || uploadStatus === 'PROCESSED' ? 'FileName: ' + fileName : ' '}
          </Text>
          <Spacer size={8} />
        </ModBox>
        <Spacer size={32} />
        <ModBox show={false}>
          {/* uploadStatus === 'PROCESSED' || uploadStatus === 'UPLOADED' */}
          <ButtonNew
            {...styles.cancelButton}
            title={'Done'}
            testID="onHandleCancelChangeFile"
            onPress={onHandleCancelChangeFile}
            borderWidth={1}
            borderColor={'BLUE'}
          />
        </ModBox>
      </Box>
      <Spacer size={40} direction={'vertical'} />
    </Box>
  )
}

const styles = {
  container: { width: '100%', align: 'center', justify: 'center' } as BoxProps,
  content: {
    width: '700px',
    align: 'center',
    justify: 'center',
  } as BoxProps,
  progressView: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    width: 80,
    height: 80,
    borderRadius: 40,
    borderColor: '#3F8C3A33' as ColorOptions,
    alignItems: 'center',
    zIndex: 10000,
    justifyContent: 'center',
  } as BoxProps,
  filledStyle: {
    width: '72px',
    height: '72px',
    borderRadius: 36,
    borderColor: '#3F8C3A' as ColorOptions,
    borderWidth: 1,
    alignItems: 'center',
    zIndex: 10000,
    justifyContent: 'center',
    backgroundColor: '#3F8C3A14' as ColorOptions,
  } as BoxProps,
  fileContainer: {
    width: '80px',
    height: '80px',
    borderRadius: 40,
    borderWidth: 1,
    borderColor: '#3F8C3A33' as ColorOptions,
    alignItems: 'center',
    backgroundColor: '#3F8C3A14' as ColorOptions,
    justifyContent: 'center',
  } as BoxProps,
  contentContainer: {
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 24,
  } as BoxProps,
  buttonContainer: {
    direction: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  cancelButton: {
    borderColor: 'TRANSPARENT',
    shadowType: 'shadowPrimary',
    titleColor: 'PRIMARY',
    type: 'secondarySmall',
  } as ButtonProps,
  proceedButton: {
    borderColor: 'TRANSPARENT',
    shadowType: 'shadowPrimary',
    titleColor: 'WHITE',
    type: 'primaryIconSmall',
    borderRadius: 6,
  } as ButtonProps,
  uploadButton: {
    borderColor: 'TRANSPARENT',
    shadowType: 'shadowPrimary',
    titleColor: 'WHITE',
    type: 'primaryIconSmall',
    borderRadius: 6,
  } as ButtonProps,
}
export { BulkBeneficiaryUploadFileProgress }
